enum InboundFaxView {
    FaxesList,
    IndexingForm,
    TriageForm
}

export { InboundFaxView };
